import axios from "axios";
import { Base_URL } from "../url";

// Main API call to save purchase requisition
export const savePurchaseRequisition = async (purchaseData, userId) => {
  try {
    // Transform the data keys to match API expectations
    const apiData = {
      pR_Type: purchaseData.prType,
      purchase_Item_Type: purchaseData.purchaseItemType,
      item: purchaseData.item,
      quantity: purchaseData.quantity,
      unit: purchaseData.unit,
      requested_Delivery_Date: purchaseData.requestedDeliveryDate,
      requested_For: purchaseData.requestedFor,
      requested_For_Code: purchaseData.requestedForCode,
      preferredVendor: purchaseData.preferredVendor,
      requestedBy: purchaseData.requestedBy
    };

    const response = await axios.post(
      `${Base_URL}/PurchaseRequisition/CreatePurchaseRequisition?UserName=${userId}`,
      apiData
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving purchase requisition!";
  }
};

// Get all merchants for Preferred Vendor dropdown
export const getMerchants = async () => {
  try {
    const response = await axios.get(`${Base_URL}/MerchantMaster/GetAllMerchants`);
    return response.data.map(item => ({
      value: item.merchantCode,
      label: `${item.merchantCode} - ${item.merchantName}`
    }));
  } catch (error) {
    throw error.response?.data || "Error fetching merchants!";
  }
};

// Get all resources for Requested By dropdown
export const getResources = async () => {
  try {
    const response = await axios.get(`${Base_URL}/SalaryProcess/ResourceMasters`);
    return response.data.map(item => ({
      value: item.resourceId,
      label: `${item.resourceId} - ${item.name}`
    }));
  } catch (error) {
    throw error.response?.data || "Error fetching resources!";
  }
};

export const getPRTypes = async () => {
  try {
    const response = await axios.get(`${Base_URL}/PRType/GetAllPRTypes`);
    return response.data.map(item => ({
      value: item.prTypeCode,
      label: `${item.prTypeCode} - ${item.prTypeDescription}`
    }));
  } catch (error) {
    throw error.response?.data || "Error fetching PR types!";
  }
};

export const getItemTypes = async () => {
  try {
    const response = await axios.get(`${Base_URL}/ItemTypeMaster/GetAllItemTypes`);
    return response.data.map(item => ({
      value: item.code,
      label: `${item.code} - ${item.description}`
    }));
  } catch (error) {
    throw error.response?.data || "Error fetching item types!";
  }
};

export const getItems = async () => {
  try {
    const response = await axios.get(`${Base_URL}/Item/ItemGetData`);
    return response.data.map(item => ({
      value: item.itemCode,
      label: `${item.itemCode} - ${item.itemName}`
    }));
  } catch (error) {
    throw error.response?.data || "Error fetching items!";
  }
};

export const getUnits = async () => {
  try {
    const response = await axios.get(`${Base_URL}/UnitMaster/GetCountUnits`);
    return response.data.map(item => ({
      value: item.code,
      label: `${item.code} - ${item.description}`
    }));
  } catch (error) {
    throw error.response?.data || "Error fetching units!";
  }
};

export const getRequestedForOptions = async (type) => {
  try {
    const response = await axios.post(`${Base_URL}/SalaryProcess/MasterData?type=${type}`);
    
    switch (type) {
      case "Resource":
        return response.data.map(item => ({
          value: item.resourceId,
          label: `${item.resourceId} - ${item.name}`
        }));
      case "Department":
        return response.data.map(item => ({
          value: item.code,
          label: `${item.code} - ${item.description}`
        }));
      case "Cost Center":
        return response.data.map(item => ({
          value: item.costCenterCode,
          label: `${item.costCenterCode} - ${item.costCenterName}`
        }));
      case "Cost Center Group":
        return response.data.map(item => ({
          value: item.groupCode,
          label: `${item.groupCode} - ${item.groupName}`
        }));
      case "Office":
        return response.data.map(item => ({
          value: item.officeCode,
          label: `${item.officeCode} - ${item.officeName}`
        }));
      case "Company":
        return response.data.map(item => ({
          value: item.companyCode,
          label: `${item.companyCode} - ${item.name}`
        }));
      default:
        return [];
    }
  } catch (error) {
    throw error.response?.data || "Error fetching requested for options!";
  }
};